import { OwnBookingsBookings } from '../../types/AdminTypes';

export const clientBookingText = (booking: OwnBookingsBookings, isComment?: string) => {
  const customerName =
    booking.Customer?.Lastname &&
    booking.Customer?.Firstname ?
      `${booking.Customer.Lastname}, ${booking.Customer.Firstname}, ` : '';
  const numberOfAdults = booking.numberOfAdults;
  const numberOfChildren = booking.numberOfChildren;
  const ageOfChildren = booking.ageOfChildren.join(', ');
  const childrenText = `${numberOfChildren}K${numberOfChildren ? `(${ageOfChildren})` : ''}`;
  const numberOfPets = booking.numberOfPets;
  const comment = booking.Comment !== '' && isComment === 'COMMENT' ? `; ${booking.Comment}` : '';

  return `${customerName}${numberOfAdults}E, ${childrenText}, ${numberOfPets}H${comment}`;
};
